import type { IProjectRepository } from '../repositories/IProjectRepository.js';

interface Deps { projectRepository: IProjectRepository; }

export function createDeleteProjectUseCase({ projectRepository }: Deps) {
  return async function deleteProject(id: string): Promise<void> {
    return projectRepository.delete(id);
  };
}
